import { createInstance } from '@amplitude/analytics-browser';
import type {
  BrowserClient,
  ValidPropertyType,
} from '@amplitude/analytics-types';
import { AmplitudeAnalyticsEvent } from '../../analytics/events';
import AnalyticsEvent from '../AnalyticsEvent';
import AnalyticsService from '../AnalyticsService';

class InternalAnalyticsService extends AnalyticsService {
  private instance!: BrowserClient;

  trackingEvents = Object.keys(AmplitudeAnalyticsEvent)
    .filter(value => !Number.isNaN(Number(value)))
    .map(key => AmplitudeAnalyticsEvent[key as any]);

  constructor(key: string, serverUrl: string) {
    super();
    this.instance = createInstance();
    this.instance.init(key, '', {
      serverUrl,
    });
  }

  setUserId = (userId: string) => {
    return this.instance.setUserId(userId);
  };

  setUserProperties = async (properties: Record<string, unknown>) => {
    const { Identify } = await import('@amplitude/analytics-browser');
    const identity = new Identify();
    Object.entries(properties).forEach(([key, value]) => {
      identity.set(key, value as ValidPropertyType);
    });
    return this.instance.identify(identity);
  };

  track = (event: AnalyticsEvent, properties?: Record<string, unknown>) => {
    return this.instance.logEvent(AnalyticsEvent[event], properties).promise;
  };
}

export default InternalAnalyticsService;
